import * as React from 'react';
import { FormField } from '@cian/ui-kit/form';
import { Input, IInputProps } from '@cian/ui-kit/input';

import { Label } from '../Label';
import { LabelTooltip } from '../LabelTooltip';
import { EPostFormFieldName } from '../../../types/postForm';

interface ITitleField {
  value: Required<IInputProps['value']>;
  onChange(value: Required<IInputProps['value']>): void;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  label?: string;
  strong?: boolean;
  withoutMargin?: boolean;
  size?: 'M' | 'XS';
}

/**
 * Поле Заголовок
 */
export const TitleField = ({
  value,
  errorMessage,
  disabled,
  required,
  onChange,
  maxLength,
  label,
  strong,
  withoutMargin,
  size,
}: ITitleField) => {
  return (
    <FormField errorMessage={errorMessage} withoutMargin={withoutMargin}>
      <Label
        required={required}
        label={label ?? 'Заголовок'}
        after={
          <LabelTooltip content={'Заголовок должен сообщать конкретную тему и быть коротким, ясным, без глаголов'} />
        }
        strong={strong}
      >
        <Input
          name={EPostFormFieldName.Title}
          value={value}
          type="text"
          invalid={Boolean(errorMessage)}
          disabled={disabled}
          size={size ?? 'M'}
          onChange={(_e, value) => onChange(value)}
          maxLength={maxLength}
        />
      </Label>
    </FormField>
  );
};
